"use strict";

define('libs/filter_format/expirationDate',['require','exports','module','underscore','moment'],function (require, exports, module) {
  var _ = require('underscore');
  var moment = require('moment');
  var EXPIRED_VALUE = 'expired';
  var EXPIRATION_FIELD = 'expirationDate';
  var EXPIRATION_START = EXPIRATION_FIELD + 'Start';
  var EXPIRATION_END = EXPIRATION_FIELD + 'End';
  return function (value, model, data) {
    var now = moment();
    var today = moment([now.year(), now.month(), now.date()]).subtract(1, 'minutes');
    var valueArray = value.split(' ');
    delete data[EXPIRATION_FIELD];
    if (_.isString(value) && valueArray[0] && valueArray[1]) {
      data[EXPIRATION_START] = now.valueOf();
      data[EXPIRATION_END] = today.add(Number(valueArray[0]), valueArray[1]).valueOf();
    } else if (String(value).toLowerCase() === EXPIRED_VALUE) {
      data[EXPIRATION_END] = now.valueOf();
    }
  };
});

